import { render } from "./BlankLayout.vue?vue&type=template&id=315e48d5&scoped=true"
import script from "./BlankLayout.vue?vue&type=script&lang=js"
export * from "./BlankLayout.vue?vue&type=script&lang=js"

import "./BlankLayout.vue?vue&type=style&index=0&id=315e48d5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315e48d5"]])

export default __exports__